import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import { setAuthTokenInterceptor } from '~/services/interceptors/set-auth-token.interceptor';

export const promotionsService = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}marketing-service/api/promotions`,
  headers: {
    ...RequestHeadersBase,
  },
});

// Note: handleRefreshInterceptor intentionally omitted. This instance is
// called from the unauthenticated homepage; on 401 we want the request to
// silently fail (no promo carousel), not trigger a refresh-then-redirect
// to /sign-in.
setAuthTokenInterceptor(promotionsService);
